import { Label } from "../../ui/label";
import { Input } from "../../ui/input";

type Props = {
  text: string;
  isEditingRef: React.MutableRefObject<boolean>;
  handleInputChange: (property: string, value: string) => void;
};

const TextInput = ({ text, isEditingRef, handleInputChange }: Props) => (
  <section className="flex flex-col border-b border-borderColor px-2 py-5">
    <div className="flex flex-row gap-1 ">
      <div className="w-full">
        <h3 className="text-[10px] uppercase px-1 mb-2">
          Text Input ({text.length})
        </h3>

        <div className="flex flex-1 items-center gap-2 rounded-sm">
          <Input
            id="text-input"
            placeholder="Type something..."
            value={text}
            className="input-ring bg-transparent text-white placeholder"
            onChange={(e) => {
              handleInputChange("text", e.target.value);
            }}
            onBlur={(e) => {
              isEditingRef.current = false;
            }}
          />
        </div>
      </div>
    </div>
  </section>
);

export default TextInput;
